import { 
    CLEAR_MAIN_TABLE_PULPIT, GET_MAIN_TABLE_PULPIT_FAIL, SET_MAIN_TABLE_LOADING, GET_MAIN_TABLE_PULPIT,
    CLEAR_CODE_MAIN_TABLE, GET_FAIL_CODE_MAIN_TABLE, GET_LOADING_CODE_MAIN_TABLE, GET_CODE_MAIN_TABLE,
    CLEAR_FINANCE_TABLE_PULPIT, GET_FINANCE_TABLE_PULPIT_FAIL, SET_FINANCE_TABLE_LOADING, GET_FINANCE_TABLE_PULPIT,
    CLEAR_INDIRECT_COST_ROW, GET_INDIRECT_COST_ROW_FAIL, SET_INDIRECT_COST_ROW_LOADING, GET_INDIRECT_COST_ROW

} from '../actions/types'

const initialState = {
    mainTable: null,
    loadingMain:true,
    errorMain:null,
    codeMain:null,
    financeTable:null,
    loadingFinance:true,
    errorFinance:null,
    indirectRow:null,
    indirectLoading:true,
    indirectError:null
}

export default (state = initialState, action) => {
    switch (action.type) {
        
        case GET_MAIN_TABLE_PULPIT:
            return{
                ...state,
                mainTable: action.payload,
                loadingMain:false
            }
        case SET_MAIN_TABLE_LOADING:
            return{
                ...state,
                loadingMain:true
            }
        case GET_MAIN_TABLE_PULPIT_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorMain:action.payload,
                loadingMain:false
            }
        case CLEAR_MAIN_TABLE_PULPIT:
            return{
                ...state,
                mainTable:null
            }
        case GET_CODE_MAIN_TABLE:
            let codes1 = action.code.split('-')
            let temp1 = state.mainTable;
            temp1[codes1[0]]['children']=action.payload
            return{
                ...state,
                codeMain: action.payload,
                loadingMain:false,
                mainTable:temp1
            }
        case GET_FINANCE_TABLE_PULPIT:
            return{
                ...state,
                financeTable: action.payload[Object.keys(action.payload)[0]],
                loadingFinance:false,
                errorFinance:null
            }
        case SET_FINANCE_TABLE_LOADING:
            return{
                ...state,
                loadingFinance:true
            }
        case GET_FINANCE_TABLE_PULPIT_FAIL:
            console.error(action.payload)
            return{
                ...state,
                errorFinance:action.payload,
                loadingFinance:false
            }
        case CLEAR_FINANCE_TABLE_PULPIT:
            return{
                ...state,
                financeTable:null
            }
        case GET_INDIRECT_COST_ROW:
            return{
                ...state,
                indirectRow: action.payload,
                indirectLoading:false,
                indirectError:null
            }
        case SET_INDIRECT_COST_ROW_LOADING:
            return{
                ...state,
                indirectLoading:true
            }
        case GET_INDIRECT_COST_ROW_FAIL:
            console.error(action.payload)
            return{
                ...state,
                indirectError:action.payload,
                indirectLoading:false
            }
        case CLEAR_INDIRECT_COST_ROW:
            return{
                ...state,
                indirectRow:null
            }
        default:
            return {...state}
       
}
}